import { render, staticRenderFns } from "./ModelPerformanceChip.vue?vue&type=template&id=64925db9&scoped=true"
import script from "./ModelPerformanceChip.vue?vue&type=script&lang=js"
export * from "./ModelPerformanceChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64925db9",
  null
  
)

export default component.exports